import { z } from 'zod';
import { DisplayReferenceSchema } from '../domain/models';
import { PaginationSchema } from '../domain/pagination';
import {
  DisplayCodeableConceptSchema,
  PaginatedBundleSchema,
} from '../domain/schema';

export const CreateDiagnosisSchema = z.object({
  code: DisplayCodeableConceptSchema,
  encounter: DisplayReferenceSchema,
  subject: DisplayReferenceSchema,
  status: DisplayCodeableConceptSchema,
  category: DisplayCodeableConceptSchema,
});

export const DiagnosisSearchSchema = PaginationSchema.extend({
  code: z.string().optional(),
  encounter: z.string().optional(),
  subject: z.string().optional(),
  status: z.string().optional(),
});

export const DiagnosisSchema = CreateDiagnosisSchema.extend({
  id: z.string().uuid(),
  encounter: DisplayReferenceSchema,
});

export const GetDiagnosisResponseSchema = DiagnosisSchema.partial();

export const DiagnosisGetAllResponseSchema = PaginatedBundleSchema.extend({
  diagnoses: GetDiagnosisResponseSchema.array(),
});

export type CreateDiagnosis = z.infer<typeof CreateDiagnosisSchema>;

export type Diagnosis = z.infer<typeof DiagnosisSchema>;

export type GetDiagnosisResponse = z.infer<typeof GetDiagnosisResponseSchema>;

export type DiagnosisGetAllResponse = z.infer<
  typeof DiagnosisGetAllResponseSchema
>;

export type DiagnosisSearchParams = z.infer<typeof DiagnosisSearchSchema>;

export type UpdateRequest = Diagnosis;
